import Preference from './Preference';

export default class CustomerCardDetails {
  id: string = "-"
  givenName: string = "-"
  surname: string = "-"
  email: string = "-"
  mobilePhone: string = "-"
  homePhone: string = "-"
  tenancyModels: any = "-"
  workPhone: string = "-"
  dateOfBirth: string = "-"
  preferences: Preference[] = []
}